module.exports = __webpack_public_path__ + "static/media/error.5ad18e4f.svg";